import { render, staticRenderFns } from "./EstelamCheck.vue?vue&type=template&id=6081f89b&scoped=true&"
import script from "./EstelamCheck.vue?vue&type=script&lang=js&"
export * from "./EstelamCheck.vue?vue&type=script&lang=js&"
import style0 from "./EstelamCheck.vue?vue&type=style&index=0&id=6081f89b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6081f89b",
  null
  
)

export default component.exports